import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import ContentWrapper from "../ContentWrapper";
import markdown from "../../lib/remark";
import Block from "../Block";
import Column from "../Column";

const propTypes = {
    image: PropTypes.shape({
        url: PropTypes.string.isRequired
    }).isRequired,
    text: PropTypes.string,
    title: PropTypes.string,
    className: PropTypes.string,
    flipTitleAndBlock: PropTypes.bool,
    titleAlignment: PropTypes.string
};

const defaultProps = {
    text: "",
    className: "",
    title: "",
    flipTitleAndBlock: false,
    titleAlignment: "top"
};

export default function ImageWithInformation({
    image,
    text,
    title,
    className,
    flipTitleAndBlock,
    titleAlignment,
    smallText
}) {

    const textColumnClasses = classnames({
        "bg-sky  lg:bg-sky-75": true
    })

    const titleClasses = classnames({
        "self-center": titleAlignment === "center",
        "self-start  lg:mt-24": titleAlignment === "top",
        "self-end  lg:mb-24": titleAlignment === "bottom",
        "bg-concord-turquoise  lg:bg-transparent  w-full lg:w-auto  py-4  lg:py-0": true
    });

    const titleInnerClasses = classnames({
        "font-header  font-bold  text-white  text-6xl": true,
        "lg:text-right": !flipTitleAndBlock && text
    });

    return (
        <div className={`${className}  lg:min-h-40  relative`}>
            <div
                style={{
                    backgroundImage: `url(${
                        image.url
                    }?w=1600&auto=compress,format)`
                }}
                className="hidden lg:block  h-full  w-full z-0  bg-cover  absolute"
            />
            <ContentWrapper className="h-full  relative" responsive>
                <Block reversed={flipTitleAndBlock} responsiveStackedReverse>
                    {text && (
                        <Column className={textColumnClasses}>
                            <ContentWrapper>
                                <div
                                    className="cms-content  cms-content--block-info  p-8  lg:px-20  lg:pt-20"
                                    dangerouslySetInnerHTML={markdown(text)}
                                />

                                {smallText && (
                                    <div className="cms-content--block-info small-text   px-8  lg:px-20">
                                        <div dangerouslySetInnerHTML={markdown(smallText)} />
                                    </div>
                                )}
                            </ContentWrapper>
                        </Column>
                    )}

                    <Column className={titleClasses}>
                        <ContentWrapper>
                            <div className={titleInnerClasses}>{title}</div>
                        </ContentWrapper>
                    </Column>
                </Block>
            </ContentWrapper>
        </div>
    );
}

ImageWithInformation.propTypes = propTypes;
ImageWithInformation.defaultProps = defaultProps;
